export function loadGoogleMapsScript(apiKey) {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve(window.google.maps); // Already loaded
      return;
    }

    // Check if script already exists
    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        resolve(window.google.maps);
      });
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.defer = true;
    script.async = true;

    script.onload = () => resolve(window.google.maps);
    script.onerror = () =>
      reject(new Error('Failed to load Google Maps JavaScript API'));

    document.head.appendChild(script);
  });
}